var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDinein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M514.839273 270.033455l-32.093091 1.559272c-205.870545 9.914182-372.48 181.620364-388.421818 397.498182h814.08c-15.36-208.174545-170.914909-376.459636-367.755637-396.427636l-25.809454-2.629818zM945.338182 738.909091H57.413818C38.539636 738.909091 23.272727 722.874182 23.272727 703.022545 23.272727 433.826909 225.931636 214.062545 479.394909 201.844364V128.977455c0-19.851636 15.266909-35.886545 34.141091-35.886546 18.897455 0 34.164364 16.034909 34.164364 35.886546V203.170909c242.036364 24.552727 431.778909 239.266909 431.778909 499.828364 0 19.851636-15.266909 35.886545-34.141091 35.886545zM58.181818 861.090909h907.636364a34.909091 34.909091 0 0 1 0 69.818182h-907.636364a34.909091 34.909091 0 0 1 0-69.818182z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinein);
export default __webpack_public_path__ + "static/media/dinein.d92d762f4886f3e472bf84ebf7cfa7c4.svg";
export { ForwardRef as ReactComponent };